import ListViewCtrl from "../util/ListViewCtrl";
import { Worker } from "../util";

export default class MeradloImportCtrl extends ListViewCtrl {

  static $inject = ["itemSource", "MeradloService"];
  constructor(itemSource, MeradloService){
    super(itemSource);
    this.selection = {};
    this.MeradloService = MeradloService
    this.file = null;
    this.importXls = Worker(this._importXls);
  }

  selectedIds(){
    return Object.keys(this.selection).filter(k => this.selection[k]);
  }

  clearSelection(){
    this.selection = {};
    this.isAllSelected = false;
  }

  toggleSelection(){
    if(this.isAllSelected){
      this.clearSelection();
    }else{
      this.itemSource.result.map(item => item.id).forEach(id => this.selection[id] = true);
      this.isAllSelected = true;
    }
  }

  importSelected(){
    this.MeradloService.importConfirm(this.selectedIds())
      .then(() => this.itemSource.load())
      .then(() => this.clearSelection());
  }

  cancelSelected(){
    this.MeradloService.importCancel(this.selectedIds())
      .then(() => this.itemSource.load())
      .then(() => this.clearSelection());
  }

  onFile($file){
    this.file = $file;
  }

  _importXls(){
    return this.MeradloService.importXls(this.file)
      .then(() => this.file = null)
      .then(() => this.itemSource.load())
      .then(() => this.clearSelection());
  }


}


// WEBPACK FOOTER //
// ./src/Meradlo/MeradloImportCtrl.js